import { Validators } from "@angular/forms"
import { IOperationPayment } from "src/app/modules/athora/athora.constants"
import { IGianosDatiOperatore, IGianosDesignazioneBeneficiari, IGianosEsecutoreConto, IGianosOperationInfo, IGianosPaymentMode, IGianosPolicyHolder, IGianosPolicyInsured, IGianosTitolareEffettivo } from "src/app/modules/isv/isv.constants"
import { IFormKey } from "src/app/modules/shared/models/forms"

export const liquidation_maturity_form_template = {
    iban: null
}

export const liquidation_maturity_form_validators = {
    iban: [Validators.required]
}

export const liquidation_maturity_form_keys: IFormKey[] = [
    {
        id: 'iban-field',
        label: 'Coordinate bancarie',
        controlName: 'iban',
        css: 'col-6',
        type: 'SELECT',
        options: []
    }
]

export interface ILiquidazioneScadenzaRequest {
    policyNumber: string;
    payments: IOperationPayment;
    liquidationSubjects?: any[]
}

export interface IIsvLiquidazioneScadenzaRequest {
    policyNumber: string;
    contraente: IGianosPolicyHolder;
    assicurato: IGianosPolicyInsured;
    polizzaOperazione: IGianosOperationInfo;
    operatoreContraente: IGianosDatiOperatore;
    esecutoreConto?: IGianosEsecutoreConto;
    designazioneBeneficiario?: IGianosDesignazioneBeneficiari[];
    titolareEffettivi?: IGianosTitolareEffettivo[];
    paymentMode: IGianosPaymentMode;
    effectDate: string;
}

 export const liquidation_maturity_operation_data_form_validators = {
    agencyCode: [Validators.required],
    policyNumber: [Validators.required],
    productCode: [Validators.required],
    productCategory: [Validators.required],
    reportScope: [Validators.required],
    additionalPaymentType: null,
    redeemType: null,
    liquidationType: [Validators.required],
    withdrawalType: null,
    operationAmount: null,
    paymentType: [Validators.required],
    fundOriginCountry: [Validators.required],
    fundOrigin: [Validators.required],
    fundOriginNote: null,
    designedBeneficiary: [Validators.required],
    contractorNotInsured: [Validators.required]
}
